import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { api } from "../services";
import type { Session } from "../services/types";
import { SideNav } from "./SideNav";
import { SessionProvider } from "./SessionContext";

// Protected layout: the rail on the left, the page on the right. The session
// is read once here and handed down through SessionProvider.

export function AppShell() {
  const navigate = useNavigate();
  const [session, setSession] = useState<Session | null | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    api.auth
      .whoAmI()
      .then((s) => {
        if (cancelled) return;
        setSession(s);
        if (!s) navigate("/login", { replace: true });
      })
      .catch(() => {
        if (cancelled) return;
        setSession(null);
        navigate("/login", { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (session === undefined) return <div className="shell" aria-busy="true" />;
  if (!session) return null;

  return (
    <SessionProvider value={session}>
      <div className="shell">
        <SideNav session={session} />
        <main className="main">
          <div className="page">
            <Outlet />
          </div>
        </main>
      </div>
    </SessionProvider>
  );
}
